import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

const SimpleFabric = forwardRef((props, ref) => {
	const screen_resolution = 72;	// DPI
	const print_resolution = 150;	// DPI
	const default_fill_color = '#F6F6F6';
	const default_ui_path = `${window.cdn_url}img/photo_editor_svg/`;

	// in first versions of Fabric, Firefox didn't support SVG, but now it hopefully will:
	const extension = (true || window.browser != 'firefox') ? '.svg' : '.png';

	const margin_size = 10;

	// '0' => SCALING DISABLED | '1' => NON-UNIFORM SCALING | '2' => UNIFORM SCALING (default):
	const scaling_mode = props?.scalling_mode ?? '2';
	
	const canvas = useRef(null);

	const is_shitty_safari = ((window?.browser ?? 'chrome') == 'safari') ? true : false;

	const [ is_zoomed, setIsZoomed ] = useState(false);
	const [ zoom_amount, setZoomAmount ] = useState(1);

	useEffect(() => {
		canvasInit(() => {
			adaptCanvasToAvailSpace();
		});

		window.addEventListener('resize', adaptCanvasToAvailSpace);

		() => {
			window.removeEventListener('resize', adaptCanvasToAvailSpace);
		}
	}, []);

	const adaptCanvasToAvailSpace = () => {
		setTimeout(() => {
			const canvas_height = $('#height_calc').height();
			const canvas_width = $('#height_calc').width();

			const zoom_amount = Math.min(1.2, (canvas_width / canvas.current.getWidth()), (canvas_height / canvas.current.getHeight()));
			$('.canvas_zoom_container').scrollTop(0);

			$('.canvas-container').css({ transform:`scale(${zoom_amount})` });

			setIsZoomed(!is_zoomed);
			setZoomAmount(zoom_amount);
		}, 500);
	};

	const canvasInit = (cb) => {
		canvas.current = new fabric.Canvas('canvas', {
			backgroundColor:default_fill_color,
			HOVER_CURSOR:'pointer',
			maxFingers:1,
			uniScaleTransform:((scaling_mode == '1') ? true : false),
		});
		canvas.current.selection = true;
		canvas.current.preserveObjectStacking = true;
		canvas.current.controlsAboveOverlay = true;
		canvas.current.enableRetinaScaling = true;
		canvas.current.on({
			'object:deselected':() => deselectElements(),
			'object:selected':() => fabricSelected(),
			'selection:updated':() => fabricSelected(),
			'before:selection:cleared':(a) => clearElement(),
		});

		fabric.Canvas.prototype.orderObjects = (compare) => {
			canvas.current.getObjects().sort(compare);
			canvas.current.requestRenderAll();
		}

		cb();
	};

	const imgTo64 = (url, callback) => {
		const image = new Image();
		image.crossOrigin = "Anonymous";
		image.onload = () => {
			var canvas = document.createElement('canvas');
			canvas.width = image.naturalWidth; // or 'width' if you want a special/scaled size
			canvas.height = image.naturalHeight; // or 'height' if you want a special/scaled size
			canvas.getContext('2d').drawImage(image, 0, 0);
			// ... or get as Data URI
			callback(canvas.toDataURL('image/png'));
		};

		image.src = url;
	};

	/* Add an external image element to the canvas */
	const addImage = (id, data, cb, adapt_to_canvas) => {
		if(data.obj_specs == undefined) data.obj_specs = {};
		if(adapt_to_canvas == undefined) adapt_to_canvas = false;

		let defaultMaginBottom = margin_size;
		if(data.marginBottom != undefined && data.marginBottom != null) {
			defaultMaginBottom = (data.marginBottom > 0) ? defaultMaginBottom * data.marginBottom : 0;
		}

		const defaults = {
			id:id,
			top:margin_size,
			left:margin_size,
			text:data.name,
			type:(adapt_to_canvas) ? ((id == 'main_image_bg') ? 'main_image_bg' : 'overlay') : 'sticker',
		};

		const props = { ...defaults, ...data.obj_specs };

		if(props.scaleY != undefined && props.scaleX == undefined) {
			props.scaleX = props.scaleY;
		} else if(props.scaleX != undefined && props.scaleY == undefined) {
			props.scaleY = props.scaleX;
		}

		imgTo64(data.url, (b64) => {
			const img_obj = new Image();
			img_obj.src = b64;
			img_obj.crossOrigin = "Anonymous";
			img_obj.onload = () => {
				/* Add image to canvas */
				var imgbox = new fabric.Image(img_obj, props);
				canvas.current.add(imgbox).setActiveObject(imgbox);

				if(adapt_to_canvas) {
					imgbox.scaleToWidth(canvas.current.getWidth());
					imgbox.scaleToHeight(canvas.current.getHeight());
				} else if(props.width == undefined && props.scaleX == undefined && props.scaleY == undefined) {
					imgbox.scaleToWidth(canvas.current.getActiveObject().getScaledWidth() * 0.48);	// 72ppi / 150ppi = 0.48 (així escalem els stickers que estaran preparats per a ressolucions x2)
				}

				canvas.current.getActiveObject().set({ originX:'center', originY:'center', }).centerH().centerV().setCoords();

				deselectElements();

				canvas.current.setActiveObject(imgbox);

				canvas.current.requestRenderAll();

				if(cb !== undefined) cb(imgbox);
			};
		});
	};

	const addB64 = (b64, id, cb) => {
		removeObjectByID('main_image');

		const props = {
			top:margin_size,
			left:margin_size,
			id:id,
			type:'main_image',
		};

		const img_obj = new Image();
		img_obj.src = b64;
		img_obj.crossOrigin = "Anonymous";
		img_obj.onload = () => {
			removeObjectByID('main_image');

			/* Add image to canvas */
			const imgbox = new fabric.Image(img_obj, props);
			canvas.current.add(imgbox).setActiveObject(imgbox);

			if(props.width == undefined && props.scaleX == undefined && props.scaleY == undefined) {
				adaptCanvasToAvailSpace();
				var avail_max_width = canvas.current.getWidth() - margin_size * 2;
				var avail_max_height = (canvas.current.getHeight() - margin_size * 2);

				var img_scaled_width = canvas.current.getActiveObject().getScaledWidth();
				var img_scaled_height = canvas.current.getActiveObject().getScaledHeight();

				if(img_scaled_width > avail_max_width) imgbox.scaleToWidth(avail_max_width);
				if(img_scaled_height > avail_max_height) imgbox.scaleToHeight(avail_max_height);
			}

			canvas.current.getActiveObject().set({ originX:'center', originY:'center' }).centerH().centerV().setCoords();

			deselectElements();
			canvas.current.setActiveObject(imgbox);

			if(props.addElement != undefined) {
				props.addElement({
					id,
					type:((data.type != undefined) ? data.type : 'image'),
					visible:true,
					name:data.name,
				});
			}

			orderObjects();
			canvas.current.requestRenderAll();

			if(cb !== undefined) cb(imgbox);
		};
	};

	const toggleLock = (id) => {
		var object = (id == undefined) ? canvas.current.getActiveObject() : getObjectByID(id);
		if(!object) return;

		object.set({
			lockRotation:!object.lockRotation,
			lockMovementX:!object.lockMovementX,
			lockMovementY:!object.lockMovementY,
			lockScalingX:!object.lockScalingX,
			lockScalingY:!object.lockScalingY,
		});

		setControls(object.id);

		canvas.current.requestRenderAll();
	};

	const getObjectByID = (objectID) => {
		var selected_object = null;
		canvas.current.getObjects().forEach((o) => {
			if(o.id === objectID) selected_object = o;
		});

		return (selected_object) ? selected_object : false;
	};

	const removeObjectByID = (objectID) => {
		var obj = getObjectByID(objectID);
		if(obj) {
			canvas.current.remove(obj);
			if (props.onRemove != undefined) props.onRemove(obj);
		}
	};

	const removeObject = (object) => {
		if(object == undefined) object = canvas.current.getActiveObject();
		canvas.current.remove(object);
		if (props.onRemove != undefined) props.onRemove(object);
	};

	const reset = (cb) => {
		canvas.current.clear();
		canvas.current.setBackgroundColor(default_fill_color);
	};

	const scaleSelectedItem = (scale) => {
		let element = canvas.current.getActiveObject();
		if(element == undefined) element = getObjectByID('main_image');	// if we don't have any element selected, we select the main_image

		const sc = scale / 100;
		element.set({ scaleX:sc, scaleY:sc }).setCoords();

		canvas.current.requestRenderAll();
	};

	const rotateSelectedItem = (rotate) => {
		let element = canvas.current.getActiveObject();
		if(element == undefined) element = getObjectByID('main_image');	// if we don't have any element selected, we select the main_image
		element.set({ angle:rotate }).setCoords();

		canvas.current.requestRenderAll();
	};

	const addBackgroundImage = (url) => {
		removeBackgroundImage();

		addImage('main_image_bg', { name:'bg', url:url }, () => {
			canvas.current.getActiveObject().set({
				selectable:false,
				evented:false,
			});

			deselectElements();
			canvas.current.requestRenderAll();
			orderObjects();
		}, true);
	};

	const addOverlayImage = (id, data) => {
		removeOverlayImage();

		addImage(id, data, () => {
			canvas.current.getActiveObject().set({
				selectable:false,
				evented:false,
			});

			deselectElements();
			canvas.current.requestRenderAll();
			orderObjects();
		}, true);
	};

	const removeBackgroundImage = () => {
		removeObjectByID('main_image_bg');
	};

	const removeOverlayImage = () => {
		removeObjectByID('overlay');
	};

	const orderObjects = () => {
		canvas.current.orderObjects((x, y) => {
			//Same type preserve
			if(x.type == y.type) return 0;

			if(x.type == 'sticker') return 1;
			if(y.type == 'sticker') return -1;

			if(x.type == 'overlay') return 1;
			if(y.type == 'overlay') return -1;

			return 0;
		});
	};

	const fabricSelected = () => {
		var current = canvas.current.getActiveObject();

		setControls(current.id);
		if(props.fabricSelected != undefined) {
			props.fabricSelected(current);
		}
		canvas.current.requestRenderAll();
	};

	const setControls = (type) => {
		if(type == undefined) type = 'sticker';

		const selected_item = canvas.current.getActiveObject();

		if(selected_item != undefined) {
			if(type == 'sticker' || type == 'main_image') {
				const notLocked = !selected_item.lockScalingX;

				selected_item.set({
					padding:2 / zoom_amount,
					rotatingPointOffset:40 / zoom_amount,
				}).setControlsVisibility({
					mtr:(true && notLocked),
					bl:(true && notLocked && scaling_mode != '0'),
					br:(true && notLocked && scaling_mode != '0'),
					tl:(true && notLocked && scaling_mode != '0'),
					tr:(true && notLocked && scaling_mode != '0'),
					mt:((type != 'main_image') ? true : false) && notLocked,
					mb:(type != 'main_image') ? true : false,
					ml:false,
					mr:false,
				});
			} else {
				selected_item.set({
					padding:0,
				}).setControlsVisibility({
					mtr:false,
					bl:false,
					br:false,
					tl:false,
					tr:false,
					mt:false,
					mb:false,
					ml:false,
					mr:false,
				});
			}

			selected_item.customiseCornerIcons({
				settings:{
					borderColor:'#000000',
					cornerBackgroundColor:'#000000',
					cornerPadding:15 / zoom_amount,
					cornerSize:35 / zoom_amount,
					cornerShape:'circle',
				},
				tr:{
					icon:`${default_ui_path}scale_tr_wt${extension}`,
				},
				br:{
					icon:`${default_ui_path}scale_br_wt${extension}`,
				},
				bl:{
					icon:`${default_ui_path}scale_bl_wt${extension}`,
				},
				tl:{
					icon:`${default_ui_path}scale_tl_wt${extension}`,
				},
				mt:{
					icon:`${default_ui_path}remove_wt${extension}`,
					settings: {
						cornerBackgroundColor:'#CA4646',
					},
				},
				mb:{
					icon:(selected_item.lockScalingX) ? `${default_ui_path}locked_wt${extension}` : `${default_ui_path}unlocked_wt${extension}`,
					settings: {
						cornerBackgroundColor:'#4BC319',
						cornerPadding:10 / zoom_amount,
					},
				},
				mtr:{
					icon:`${default_ui_path}rotate_wt${extension}`,
					settings: {
						cornerBackgroundColor:'#F5A000',
						cornerPadding:10 / zoom_amount,
					},
				},
			}, () => {
				canvas.current.requestRenderAll();
			});
		}

		canvas.current.customiseControls({
			tr:{
				action:'scale',
			},
			br:{
				action:'scale',
			},
			bl:{
				action:'scale',
			},
			tl:{
				action:'scale',
			},
			mt:{
				action:(e, target) => {
					removeObject(target);
				}
			},
			mb:{
				action:(e, target) => {
					toggleLock();
				}
			},
			mtr:{
				action:'rotate',
			},
		});
	};

	const clearElement = () => {
		if(props.fabricUnselected !== undefined) props.fabricUnselected();
	};

	const deselectElements = () => {
		canvas.current.discardActiveObject();
		canvas.current.requestRenderAll();
		if(props.fabricUnselected !== undefined) props.fabricUnselected();
	};

	const dataURLtoFile = (dataurl, filename) => {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while(n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new File([u8arr], filename, { type:mime });
	};

	const zoomIt = (factor) => {
		if(is_shitty_safari) return;

		canvas.current.setWidth(canvas.current.getWidth() * factor);
		canvas.current.setHeight(canvas.current.getHeight() * factor);

		if(canvas.current.backgroundImage) {
			// Need to scale background images as well
			canvas.current.backgroundImage.scaleToWidth(canvas.current.getWidth());
			canvas.current.renderAll();
		}

		const objects = canvas.current.getObjects();
		for(var i in objects) {
			objects[i].scaleX = objects[i].scaleX * factor;
			objects[i].scaleY = objects[i].scaleY * factor;
			objects[i].left = objects[i].left * factor;
			objects[i].top = objects[i].top * factor;

			objects[i].setCoords();
		}
		canvas.current.requestRenderAll();
		canvas.current.calcOffset();
	};

	useImperativeHandle(ref, () => ({
		exportToJpeg() {
			const resolution_converter_factor_in = parseInt(10 * print_resolution / screen_resolution) / 10;
			const resolution_converter_factor_out = 1 / resolution_converter_factor_in;
			zoomIt(resolution_converter_factor_in);
	
			const imgData = canvas.current.toDataURL({ format:'jpeg', quality:0.8 });

			zoomIt(resolution_converter_factor_out);
	
			canvas.current.clear();
	
			const file = dataURLtoFile(imgData, 'filename.jpg');
			return { b64:imgData, file };
		},

		addImage(id, data, cb, adapt_to_canvas) {
			addImage(id, data, cb, adapt_to_canvas);
		},

		addOverlayImage(id, data) {
			addOverlayImage(id, data);
		},

		addB64(b64, id, cb) {
			addB64(b64, id, cb);
		},

		reset(cb) {
			reset(cb);
		},

		orderObjects() {
			orderObjects();
		},

		scaleSelectedItem(scale) {
			scaleSelectedItem(scale);
		},

		rotateSelectedItem(rotate) {
			rotateSelectedItem(rotate);
		},

		removeOverlayImage() {
			removeOverlayImage();
		},

		addBackgroundImage(url) {
			addBackgroundImage(url);
		},

		getObjectByID(objectID) {
			getObjectByID(objectID);
		},

		deselectElements() {
			deselectElements();
		},

		resetCanvas(cb) {
			canvas.current.clear();
			if(cb != undefined) cb();
		},

		toggleLock(id) {
			toggleLock(id);
		},
	}), []);

	return (
		<div id="height_calc" class={`canvas_zoom_container${(is_zoomed) ? ' is_zoomed' : ''}`}>
			<canvas
				id="canvas"
				class="original_color_item"
				width={props?._width ?? 400}
				height={props?._height ?? 400}
			/>
		</div>

	);
});

export default SimpleFabric;